import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Bioseguridad/filtrarBioSeguridad`, method: 'POST', body: values, token: token})
}